import React, { useState } from "react";
import { Button } from "primereact/button";
import research from "../assets/images/search.svg";

export default function ResearchPopup(props:any) {
  const categories = ["Sales", "Marketing", "Insurance", "Tax"];
  const [activeCategory, setActiveCategory] = useState("Sales");
  const Data = [
    { label: "Sales", title: "Sales documents were uploaded", desc: "How many sales documents were uploaded last year?" },
    { label: "Tax", title: "Tax documents were uploaded", desc: "How many tax documents were uploaded last year?" },
    { label: "Insurance", title: "Insurance documents were uploaded", desc: "How many insurance documents were uploaded last year?" },
    { label: "Sales", title: "Sales documents were uploaded", desc: "How many sales documents were uploaded last year?" },
    { label: "Tax", title: "Tax documents were uploaded", desc: "How many tax documents were uploaded last year?" },
    { label: "Insurance", title: "Insurance documents were uploaded", desc: "How many insurance documents were uploaded last year?" },
  ];
  return (
    <div className="mt-3">
      <div className="d-flex align-items-center justify-content-between px-3 py-2 bg-white border rounded mx-3">
        <div className="text-muted small">
          <img src={research} alt="Logo" className="me-2" />
          <span>Researching:</span> <span className="fw-semibold">Sales</span> &gt; <span className="fw-semibold">Sales Document</span>
        </div>
        <div className="text-muted small">
          <span>3 documents, 850 pages</span>
        </div>
      </div>
      <div className="d-flex px-3 gap-2 my-3 flex-wrap">
        {categories.map((cat, idx) => (
          <Button key={idx} onClick={() => setActiveCategory(cat)} className={`alexandria-btn ${activeCategory === cat ? "primary-btn " :"primary-inactive-btn"}`}>
            {cat}
          </Button>
        ))}
      </div>
      <div className="row row-cols-3 g-3 px-3 mt-3">
        {Data.map((item, idx) => (
          <div key={idx} className="col">
            <div className="card h-100 shadow-sm border p-3 rounded-3 d-flex flex-column justify-content-between">
              <div>
                <div className="fw-semibold mb-1 text-dark">{item.title}</div>
                <div className="text-muted">{item.desc}</div>
              </div>
              <div className="d-flex justify-content-end ">
                <input type="checkbox" className="" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-start gap-2 px-3 mt-5">
        <Button label="Start Chat" className="alexandria-btn primary-btn" />
        <Button label="Cancel" className="alexandria-btn secondary-btn" onClick={props.onHide} />
      </div>
    </div>
  );
}
